import React, { useState, useMemo, useEffect } from 'react'
import IPButton from '../../../../../components/IPButton'
import Translations from '../../../../../translations'
import { translate } from '../../../../../base/localization'
import { BaseComponentWithContextProps, componentWithContext } from '../../../../../base/customHooks/componentHOC'
import { useCustomReducer } from '../../../../../base/customHooks'
import InputCampaign from '../../../../../components/InputCampaign'
import Table from '../../../../../components/Table'
import Swal from 'sweetalert2'
import { ISapRequest, ISapResponse } from '../models/models'
import { getDateByTimezoneOffset } from '../../../../../base/utils/dataHelper'
import { FilterListApi } from '../services/filterListApi'
import IPRadio from '../../../../../components/IPRadio'
import { CreateReceiptApi } from '../services/createReceiptApi'
import { ISelectOption } from '../../../HomeAndSiteOperation/BulkAdding/components/BulkAdding'
import IPSelectBox from '../../../../../components/IPSelectBox'
import IPInput from '../../../../../components/IPInput'
import { getCompanyApi } from '../../../components/api'
import { ICompany } from '../../../components/models/models'

interface ISapState {
  radioSelect: number
  dealerCode: string
  orderNumber: string
  isDone: ISelectOption[]
  type: ISelectOption[]
  selectedType: any
  company: ISelectOption[]
  bankSelectOptions: ISelectOption[]
  bankSelectOption: any
  threeDOptions: ISelectOption[]
  threeDOption: any
  currencyOptions: ISelectOption[]
  currencyOption: any
}

function SAP(props: BaseComponentWithContextProps) {
  const t = translate(Translations)
  const inititalStartDate = new Date()
  inititalStartDate.setDate(1)
  inititalStartDate.setHours(0)
  inititalStartDate.setMinutes(0)
  inititalStartDate.setSeconds(0)
  const [startDate, setStartDate] = useState(inititalStartDate)
  const [endDate, setEndDate] = useState(new Date())
  const [sapData, setSapData] = useState<ISapResponse[]>([])
  const [filteredSapData, setFilteredSapData] = useState<ISapResponse[]>([])
  const [success, setSuccess] = useState<number>(2)
  const [selectedCompany, setSelectedCompany] = useState<any>(null)

  const getInitialState = (): ISapState => {
    return {
      radioSelect: 0,
      dealerCode: '',
      orderNumber: '',
      selectedType: null,
      isDone: [
        { label: 'Hepsi', value: 2 },
        { label: 'Başarılı', value: 1 },
        { label: 'Başarısız', value: 0 },
      ],
      company: [],
      type: [
        { label: 'Satış', value: 'Satış' },
        { label: 'Ödeme', value: 'Finansal' },
      ],
      bankSelectOptions: [],
      bankSelectOption: null,
      threeDOptions: [
        { label: 'Evet', value: 'true' },
        { label: 'Hayır', value: 'false' },
      ],
      threeDOption: null,
      currencyOptions: [
        { label: 'TL', value: 'TL' },
        { label: 'USD', value: 'USD' },
        { label: 'EUR', value: 'EUR' },
      ],
      currencyOption: null,
    }
  }
  const intialState = getInitialState()
  const [state, setState] = useCustomReducer<ISapState>(intialState)
  const [showFilterRow, setShowFilterRow] = useState(false)

  const toDateTimeLocal = date => {
    return date
      .toLocaleString('sv-SE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
      .replace(' ', 'T')
  }

  const tableColumns = useMemo(
    () => [
      {
        Header: 'Seçim',
        accessor: 'col1',
      },
      {
        Header: 'İşlem Tipi',
        accessor: 'col2',
      },
      {
        Header: 'İşlem Anı',
        accessor: 'col3',
      },
      {
        Header: 'Şirket',
        accessor: 'col13',
      },
      {
        Header: 'Bayi',
        accessor: 'col4',
      },
      {
        Header: 'Banka',
        accessor: 'col5',
      },
      {
        Header: 'Kart No',
        accessor: 'col6',
      },
      {
        Header: 'Kart İsmi',
        accessor: 'col7',
      },
      {
        Header: 'Toplam Tutar',
        accessor: 'col8',
        Cell: ({ value }) => {
          if (typeof value === 'number') {
            return value.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          }
          return value
        },
      },
      {
        Header: 'Tutar',
        accessor: 'amount',
        Cell: ({ value }) => {
          if (typeof value === 'number') {
            return value.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          }
          return value
        },
      },
      {
        Header: 'Para Birimi',
        accessor: 'currency',
      },
      {
        Header: 'Taksit',
        accessor: 'col9',
      },
      {
        Header: 'Sipariş',
        accessor: 'col10',
      },
      {
        Header: 'Makbuz',
        accessor: 'makbuz',
      },
      {
        Header: 'Vade Farkı',
        accessor: 'kkvade',
      },
      {
        Header: 'Sipariş Açıklama',
        accessor: 'col11',
      },
      {
        Header: 'Hata Açıklama',
        accessor: 'col12',
      },
      {
        Header: 'Oluşturan',
        accessor: 'col14',
      },
    ],
    []
  )
  const tableData = useMemo(
    () =>
      filteredSapData?.map((item, index) => {
        const data = {
          col1: item.IsDone ? (
            <span style={{ color: 'green' }}>Kayıt Oluşturuldu</span>
          ) : item.ProcessType === 'Satış Siparişi' ? (
            <IPButton
              text={`Sipariş Oluştur`}
              disabled={true}
              onClick={() => makbuzOlustur(item.Id, 'Sipariş')}
              style={{ width: '15%', backgroundColor: 'grey', cursor: 'default' }}
            />
          ) : (
            <IPButton
              text={`Makbuz Oluştur`}
              onClick={() => makbuzOlustur(item.Id, 'Makbuz')}
              style={{ width: '15%' }}
            />
          ),
          col2: item.ProcessType,
          col3: item.ProcessDate.toLocaleString(),
          col13: state.company?.find(company => company.value.toString() === item.Company.toString())?.label || '',
          col4: item.DealerSapCode && item.DealerSapCode.replace('0000', ''),
          col5: item.BankName,
          col6: item.CardNumber,
          col7: item.CardNameSurname,
          col8: parseFloat(item.TotalPrice.toFixed(2)),
          col9: item.Installment,
          amount: parseFloat(item.Price?.toFixed(2) ?? '0'),
          currency: item.Currency ?? 'TL',
          col10: item.DocumenNumber,
          makbuz: item.SapRecordNumber,
          kkvade: item.TransactionInterestNumber,
          col14: (
            <span>
              {item.Username} - {item.ClickedTime?.toLocaleString()}
            </span>
          ),
          col11: <p style={{ color: 'green' }}>{item.Description}</p>,
          col12: item.ErrorMessage !== '[[[]]]' && (
            <div
              dangerouslySetInnerHTML={{
                __html: item.ErrorMessage,
              }}
            ></div>
          ),
        }
        return data
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }),
    [filteredSapData, state.company]
  )

  useEffect(() => {
    getCompanies()
  }, [])

  const getCompanies = async () => {
    try {
      const companyList: ICompany[] = await getCompanyApi()
      const companiesOptions: ISelectOption[] = companyList.map(company => ({
        label: company.Name,
        value: company.Code.toString(),
      }))
      setState({ company: companiesOptions })
    } catch (err) {
      console.log('Fetch Companies Error:', err)
    }
  }


  const getSap = async () => {
    if (!startDate || !endDate) {
      Swal.fire({
        icon: 'error',
        title: 'Lütfen tarih giriniz',
        showConfirmButton: true,
        allowOutsideClick: false,
      })
      return
    }
    const req: ISapRequest = {
      Company: selectedCompany?.value,
      StartDate: startDate && (getDateByTimezoneOffset(startDate) as any),
      EndDate: endDate && (getDateByTimezoneOffset(endDate) as any),
      IsDone: success,
      DealerCode: state.dealerCode,
      Type: state.selectedType?.value,
      OrderNumber: state.orderNumber,
    }
    props.showLoading()
    const filterListApi: FilterListApi = new FilterListApi({})
    await filterListApi
      .filterList(req)
      .then(result => {
        if (result) {
          console.log(result)
          setSapData(result) // Orijinal veriyi koru
          setFilteredSapData(result) // Filtrelenmiş veri başlangıçta aynı

          // Banka seçeneklerini oluştur
          const uniqueBankLabels = {}
          const bankOptions = result
            .filter(x => x.BankName)
            .map(x => ({
              value: x.BankName,
              label: x.BankName.toUpperCase(),
            }))
            .filter(option => {
              if (!uniqueBankLabels[option.label]) {
                uniqueBankLabels[option.label] = true
                return true
              }
              return false
            })

          setState({ bankSelectOptions: bankOptions })
          setShowFilterRow(true)
        }
        props.hideLoading()
      })
      .catch((err: any) => {
        Swal.fire({
          icon: 'error',
          title: err.description,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
        props.hideLoading()
      })
  }

  //#region Detaylı Filtreleme fonksiyonu
  const filterSapData = () => {
    let filteredData = sapData // Her zaman orijinal veriden başla

    // Banka filtresi
    if (state.bankSelectOption) {
      filteredData = filteredData.filter(item =>
        item.BankName?.toUpperCase().includes(state.bankSelectOption.label.toUpperCase())
      )
    }

    // 3D Secure filtresi - ProcessType içinde "3D" geçip geçmediğini kontrol eder
    if (state.threeDOption) {
      if (state.threeDOption.value === 'true') {
        // Evet seçildiyse, ProcessType içinde "3D" geçenleri getir
        filteredData = filteredData.filter(item => item.ProcessType?.toUpperCase().includes('3D'))
      } else if (state.threeDOption.value === 'false') {
        // Hayır seçildiyse, ProcessType içinde "3D" geçmeyenleri getir
        filteredData = filteredData.filter(item => !item.ProcessType?.toUpperCase().includes('3D'))
      }
    }

    // Currency filtresi
    if (state.currencyOption) {
      filteredData = filteredData.filter(item => (item.Currency ?? 'TL') === state.currencyOption.value)
    }

    setFilteredSapData(filteredData) // Filtrelenmiş veriyi set et, orijinali koru
  }
  //#endregion

  const makbuzOlustur = async (id: number, text: string) => {
    Swal.fire({
      icon: 'question',
      title: `${text} kaydı oluşturulacaktır. Devam etmeden önce banka hesaplarınızı kontrol etmeyi unutmayın.`,
      showConfirmButton: true,
      allowOutsideClick: false,
      showDenyButton: true,
      confirmButtonText: 'Evet',
      denyButtonText: 'Hayır',
    }).then(async result => {
      if (result.isConfirmed) {
        createReceipt(id)
      }
    })
  }

  const createReceipt = async (id: number) => {
    props.showLoading()
    const createReceiptApi: CreateReceiptApi = new CreateReceiptApi({})
    await createReceiptApi
      .createReceipt(id)
      .then(result => {
        if (result) {
          setSapData((prevState: any) => prevState.filter(item => item.Id !== id))
          setFilteredSapData((prevState: any) => prevState.filter(item => item.Id !== id))
          Swal.fire({
            icon: 'success',
            title: result,
            showConfirmButton: true,
            allowOutsideClick: false,
          })
        }
        props.hideLoading()
      })
      .catch((err: any) => {
        Swal.fire({
          icon: 'error',
          title: err.description,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
        props.hideLoading()
      })
  }

  const getDate = async (data: any, title: string) => {
    if (title === 'Start') setStartDate(data)
    else setEndDate(data)
  }

  useEffect(() => {
    Swal.fire({
      icon: 'warning',
      title: `Makbuz kaydı oluşturmadan önce SADECE YAPI KREDİ İÇİN banka hesaplarını kontrol edip ödeme alındığını doğrulamayı unutmayın. Makbuz oluşturma sistemi diğer bankaları kendi kontrol etmektedir.`,
      showConfirmButton: true,
      allowOutsideClick: false,
      showDenyButton: false,
      confirmButtonText: 'Evet',
    })
  }, [])

  return (
    <div className=''>
      <div className='content col-lg-12 m-auto'>
        <div className='card'>
          <div className='card-header'>
            <span className='h4'>{t('pages.admin.CreditCardOperation.SAP.header')}</span>
          </div>
          <div className='card-body'>
            <div
              className='main-filter-form'
              style={{
                border: '2px solid #dc3545',
                borderRadius: '8px',
                padding: '20px',
                backgroundColor: '#fff5f5',
                marginBottom: '20px',
              }}
            >
              <h6 style={{ marginBottom: '20px', color: '#dc3545', fontWeight: 'bold' }}>Ana Arama Kriterleri</h6>

              <div className='row g-3'>
                <div className='col-md-2'>
                  <label className='form-label' style={{ fontSize: '0.9rem', fontWeight: '500', color: '#495057' }}>
                    Başlangıç Tarihi
                  </label>
                  <InputCampaign
                    type='date'
                    id='StartDate'
                    name='StartDate'
                    label={''}
                    value={toDateTimeLocal(startDate)}
                    onChange={e => getDate(e.target.value, 'Start')}
                    isActive
                  />
                </div>
                <div className='col-md-2'>
                  <label className='form-label' style={{ fontSize: '0.9rem', fontWeight: '500', color: '#495057' }}>
                    Bitiş Tarihi
                  </label>
                  <InputCampaign
                    type='date'
                    id='EndDate'
                    name='EndDate'
                    label={''}
                    value={toDateTimeLocal(endDate)}
                    onChange={e => getDate(e.target.value, 'End')}
                    isActive
                  />
                </div>
                <div className='col-md-2'>
                  <label className='form-label' style={{ fontSize: '0.9rem', fontWeight: '500', color: '#495057' }}>
                    Bayi Kodu
                  </label>
                  <IPInput
                    type='text'
                    className='form-control'
                    placeholder='Bayi kodu giriniz'
                    onChange={e => setState({ dealerCode: String(e.target.value) })}
                    value={state.dealerCode && state.dealerCode}
                  />
                  <small className='text-muted'>* Boş bırakırsanız hepsi</small>
                </div>
                <div className='col-md-2'>
                  <label className='form-label' style={{ fontSize: '0.9rem', fontWeight: '500', color: '#495057' }}>
                    Sipariş/Makbuz/Vade No
                  </label>
                  <IPInput
                    type='text'
                    className='form-control'
                    placeholder='Numara giriniz'
                    onChange={e => setState({ orderNumber: String(e.target.value) })}
                    value={state.orderNumber && state.orderNumber}
                  />
                  <small className='text-muted'>* Boş bırakırsanız hepsi</small>
                </div>
                <div className='col-md-2'>
                  <label className='form-label' style={{ fontSize: '0.9rem', fontWeight: '500', color: '#495057' }}>
                    Şirket
                  </label>
                  <IPSelectBox
                    isClearable
                    placeholder='Şirket seçiniz'
                    options={state.company}
                    value={selectedCompany}
                    onChangeSingle={option => {
                      setSelectedCompany(option)
                    }}
                  />
                  <small className='text-muted'>* Boş bırakırsanız hepsi</small>
                </div>
                <div className='col-md-2'>
                  <label className='form-label' style={{ fontSize: '0.9rem', fontWeight: '500', color: '#495057' }}>
                    Ödeme Tipi
                  </label>
                  <IPSelectBox
                    isClearable
                    placeholder='Ödeme tipi seçiniz'
                    options={state.type}
                    value={state.selectedType}
                    onChangeSingle={option => {
                      setState({ selectedType: option })
                    }}
                  />
                  <small className='text-muted'>* Boş bırakırsanız hepsi</small>
                </div>
              </div>

              <div className='row g-3 mt-2'>
                <div className='col-md-2'>
                  <label className='form-label' style={{ fontSize: '0.9rem', fontWeight: '500', color: '#495057' }}>
                    Durum
                  </label>
                  <IPSelectBox
                    placeholder='Durum seçiniz'
                    options={state.isDone}
                    value={state.isDone.filter(a => a.value === success)}
                    onChangeSingle={option => {
                      setSuccess(Number(option.value))
                    }}
                  />
                </div>
              </div>

              <div className='row mt-4 justify-content-center'>
                <div className='col-3 text-center'>
                  <IPButton
                    text='📊 Verileri Göster'
                    className='btn btn-danger px-3 py-1'
                    onClick={getSap}
                    style={{
                      borderRadius: '6px',
                      fontWeight: '500',
                      fontSize: '0.9rem',
                      minWidth: '120px',
                    }}
                  />
                </div>
              </div>
            </div>

            {showFilterRow && (
              <>
                <div
                  className='detailFilter'
                  style={{
                    marginTop: '15px',
                    border: '2px solid #9c9cf1',
                    borderRadius: '8px',
                    padding: '15px',
                    backgroundColor: '#f8f9fa',
                    position: 'relative',
                  }}
                >
                  <h6 style={{ marginBottom: '15px', color: '#495057', fontWeight: 'bold' }}>Detaylı Filtreleme</h6>

                  {/* İlk Satır - Dropdown Filtreler */}
                  <div className='row mb-3'>
                    <div className='col-md-3'>
                      <label className='form-label' style={{ fontSize: '0.9rem', fontWeight: '500', color: '#495057' }}>
                        Banka
                      </label>
                      <IPSelectBox
                        isClearable
                        placeholder='Banka Seçiniz'
                        options={state.bankSelectOptions}
                        value={state.bankSelectOption}
                        onChangeSingle={option => {
                          setState({ bankSelectOption: option })
                        }}
                      />
                    </div>
                    <div className='col-md-3'>
                      <label className='form-label' style={{ fontSize: '0.9rem', fontWeight: '500', color: '#495057' }}>
                        3D Secure Durumu
                      </label>
                      <IPSelectBox
                        isClearable
                        placeholder='3D Durumu Seçiniz'
                        options={state.threeDOptions}
                        value={state.threeDOption}
                        onChangeSingle={option => {
                          setState({ threeDOption: option })
                        }}
                      />
                      <small className='text-muted'>* İşlem tipi içinde "3D" geçip geçmediğini kontrol eder</small>
                    </div>
                    <div className='col-md-3'>
                      <label className='form-label' style={{ fontSize: '0.9rem', fontWeight: '500', color: '#495057' }}>
                        Kur Tipi
                      </label>
                      <IPSelectBox
                        isClearable
                        placeholder='Kur Tipi Seçiniz'
                        options={state.currencyOptions}
                        value={state.currencyOption}
                        onChangeSingle={option => {
                          setState({ currencyOption: option })
                        }}
                      />
                    </div>
                  </div>

                  {/* Buton kendi satırında ortalanmış */}
                  <div className='row justify-content-center'>
                    <div className='col-md-3'>
                      <IPButton
                        type='button'
                        className='btn btn-primary px-4 py-2'
                        text='🔍 Detaylı Süz'
                        onClick={filterSapData}
                        style={{
                          height: '42px',
                          borderRadius: '6px',
                          fontWeight: '500',
                          fontSize: '0.95rem',
                        }}
                      />
                    </div>
                  </div>
                </div>
              </>
            )}

            <div className='m-4'>
              <Table
                columns={tableColumns}
                data={tableData}
                currentPage={0}
                headerName={`İşlem Tarihi Aralığı: ${new Date(startDate).toLocaleDateString()} - ${new Date(
                  endDate
                ).toLocaleDateString()}`}
                columnCount={18}
                backgroundColor='red'
                color='white'
                textAlign={true}
              />
            </div>
            {/* <IPButton text={`<< SSP ve Makbuz Oluştur >>`} onClick={getSap} style={{ width: "15%" }} /> */}
            {/* {
              sapData && sapData.length > 0 &&
              <div className='m-10'>

            <IPButton text={`<< Makbuz Oluştur >>`} onClick={createReceipt} style={{ width: "15%" }} />
          </div>
            } */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default componentWithContext(SAP)
